import type { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  pending: boolean;
}

export function ConfiguratorInteractionBoundary({ children, pending }: Props) {
  const inertWhilePending = pending ? { inert: "" } : {};

  return (
    <div aria-busy={pending} {...inertWhilePending}>
      {children}
    </div>
  );
}
